export const API_Url = `https://js.cexplorer.io/api-static/pool/pool18gysxqfwz4j8rm3vlh6677vs9n23prvfr7gwe88mhn5uudgx9ng.json`;
export const TIMEOUT_SECONDS = 10;
